<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-09-20 10:51:34
 * @LastEditors: lkz
 * @LastEditTime: 2021-11-24 11:42:07
 -->
<template>
  <div class="create-group-view">
    <el-form :model="form" label-position="right" label-width="100px">
      <slot></slot>
      <el-form-item
        v-for="(item, idx) in formItemList"
        :key="idx"
        :required="item.options === 2"
        :label="item.fieldName + '：'">
        <!-- 图片 -->
        <template v-if="item.wordType === 10">
          <!--<ImgGroupUpload 
            @change="handleImgUploadSuccess" 
            :width="90" 
            :height="90" 
            :formatList="imgFormatList" 
            :limit=5
            :action="imgUploadUrl"
            :value="form[item.value]">
          </ImgGroupUpload>-->
          <div  class='drapUpload'>
            <div class='imgList'>
              <span v-for="(item,index) in form.woPictures" :key="index">
                <img  :src="item" alt="">
                <i class="el-icon-error" @click="delbtnpic(index)"></i>
              </span>
            </div>
            <el-upload
              v-show='form.woPictures.length < 5'
              style='display:inline'
              :action="imgUploadUrl"
              list-type="picture-card"
              name="data"
              :drag='true'
              :limit='5'
              accept=".jpg,.png"
              :on-success="handlePictureCardPreview"
              :show-file-list="false">
              <i class="el-icon-plus"></i>
            </el-upload>
            <!-- 一线工作台才展示拖动图片地址功能 -->
            <div class='dragWorkUpload' v-if='workType === 1'> 
              <work-upload  @uploadImg='workImgs'></work-upload>
            </div> 
          </div>
        </template>
        <!-- 视频 -->
        <template v-else-if="item.wordType === 11">
          <video-upload
            v-model="form[item.value]"
            :size="videoSize"
            :accept="videoFormatList.join(',')"
            :uploadUrl="uploadUrl">
          </video-upload>
        </template>
        <!-- 附件 -->
        <template v-else-if="item.wordType === 12">
          <file-upload
            v-model="form[item.value]"
            :size="fileSize"
            :uploadUrl="uploadUrl">
          </file-upload>
        </template>
        <template v-else-if="item.value === 'woDescribe'">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="300"
            show-word-limit
            :placeholder="item.fieldRemark || '请填写描述'"
            style="width:400px;"
            v-model.trim="form[item.value]">
          </el-input>
        </template>
        <item-template v-if="item.value != 'woDescribe'" :placeholder='item.fieldName' :wordType="item.wordType" v-model="form[item.value]"
          :options="item.fieldOptionForms" :cascaderProps="item.cascaderProps" :multiples="false"></item-template>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ImgGroupUpload from '@ui/manage/ImgGroupUpload'
import ItemTemplate from './ItemTemplate'
import VideoUpload from './VideoUpload'
import FileUpload from './FileUpload'
import workUpload from '../../invoices/components/workUpload.vue'

export default {
  name: 'createGroup',
  components: {
    ItemTemplate,
    ImgGroupUpload,
    VideoUpload,
    FileUpload,
    workUpload
  },
  props: {
    /**
     * formItemList 需要展示的过滤表单
     * fieldName 表单名称
     * value 对应的后台字段
     * wordType 表单类型 1数字型,2日期型,3枚举型,4文本型,5单选框,6复选框,7下拉框多选8下拉框级联单选
     * fieldOptionForms 选项 结构为name->label, id->value  
     */
    formItemList: Array,
    workType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {
        woPictures: []
      },
      imgFormatList: ['.png', '.jpeg', '.jpg'], // 图片格式
      videoFormatList: ['.mkv', '.mp4'], // 视频格式
      videoSize: 100 * 1024 * 1024, // 视频大小
      fileSize: 20 * 1024 * 1024, // 附件大小
      imgUploadUrl: 'upload/uploadPic_json.json',
      uploadUrl: '/cdnadmin/admin/upload/uploadFile_json',
      exextendWordsName: [], // 扩展字段集合
      requiredWordsName: [], // 必填字段集合
      token: ''
    }
  },
  watch: {
    formItemList() {
      this.getFormKeys()
    }
  },
  created() {
    this.getImgUploadUrl()
    this.getVideoHost()
    this.getFormKeys()
  },
  methods: {
    getImgUploadUrl() {
      const popUri = '/popxinyunadmin/admin/xinyunpop/'
      const xinyunUri = '/yunjixinyunadmin/admin/xinyun/'
      const { pathname } = window.location
      let url = this.imgUploadUrl
      if (pathname.includes('popWeb') || pathname.includes('popadminweb')) {
        url = `${popUri}${url}`
      } else if (pathname.includes('xinyunweb')) {
        url = `${xinyunUri}${url}`
      }
      this.imgUploadUrl = url
    },
    // 获取视频上传地址对应的host
    getVideoHost() {
      const { hostname } = window.location
      const y = hostname.split('.')[0]
      const config = {
        t: 'https://cdn-do-dev.yunjiglobal.com', // 阿里云
        txst: 'https://cdn-txst.yunjiglobal.com', // 腾讯云
        y: 'https://cdn-do-dev.yunjiglobal.com', // 本地 根据代理的环境切换
        't-do-dev': 'https://cdn-do-dev.yunjiglobal.com',
        'customerserviceadmin-do-dev': 'https://cdn-do-dev.yunjiglobal.com'
      }
      const host = config[y] || 'https://cdn.yunjiglobal.com' // 都不满足则是现网
      this.uploadUrl = `${host}${this.uploadUrl}`
    },
    // 获取表单属性
    getFormKeys() {
      const param = {}
      const KeyVal = {
        woPictures: [],
        woVideo: ''
      }
      this.exextendWordsName = []
      this.requiredWordsName = []
      this.formItemList.forEach((item) => {
        param[item.value] = KeyVal[item.value] || ''
        const arr = ['', '', [], '', '', '', [], [], []]
        param[item.value] = arr[item.wordType] || ''
        if (item.wordExtend === 2) this.exextendWordsName.push(item.value)
        if (item.options === 2) this.requiredWordsName.push(item.value)

        if (item.value === 'emergencyStage') {
          item.fieldOptionForms = [
            {
              name: '一般',
              id: 0
            }, {
              name: '紧急',
              id: 1
            }, {
              name: '非常紧急',
              id: 2
            }
          ]
        }
        if (item.value === 'woAppeals') {
          item.fieldOptionForms = [
            {
              name: '催发货',
              id: '0'
            }, {
              name: '补发',
              id: '1'
            }, {
              name: '退款',
              id: '2'
            }, {
              name: '补偿',
              id: '3'
            }, {
              name: '催物流',
              id: '4'
            }, {
              name: '修改真名',
              id: '5'
            }, {
              name: '其他',
              id: '6'
            }
          ]
        }
        if (item.value === 'woPictures') {
          param.woPictures = []
        }
        if (item.value === 'woVideo') {
          // param.woVideo = 'http://static.yunjiweidian.com/admin_dev/68ed080a42556731ecb327956c6e1197.mp4'
        }
        if (item.value === 'woDescribe' && item.ifPlaintext) { // 如果明文展示就默认赋值
          param[item.value] = item.fieldRemark
        }
        // 获取默认选中值处理
        if (item.fieldOptionForms && item.fieldOptionForms.length) {
          const arr = []
          item.fieldOptionForms.forEach((i) => {
            if (i.isSelect) arr.push(i.id)
          })
          param[item.value] = param[item.value] === '' ? arr[0] || '' : arr
        }
      })
      this.form = param
    },
    // handleImgUploadSuccess(file) {
    //   this.form.woPictures = JSON.parse(JSON.stringify(file))
    // },
    handleSubmit() {
      const param = {}
      const extensionCode = {}
      for (const k in this.form) {
        if (this.requiredWordsName.indexOf(k) !== -1) {
          if (Array.isArray(this.form[k])) {
            if (!this.form[k].length) {
              console.log(`-----${k} is null------`, this.form[k])
              this.$message.error('请完善工单必填信息')
              return
            }
          } else if (!this.form[k] && this.form[k] !== 0) {
            console.log(`-----${k} is null------`, this.form[k])
            this.$message.error('请完善工单必填信息')
            return
          }
        }
        if (this.exextendWordsName.indexOf(k) === -1) {
          param[k] = this.form[k]
        } else {
          extensionCode[k] = this.form[k]
        }
      }
      if (extensionCode[109] && extensionCode[109].indexOf('-') === -1) {
        this.$message.error('区号必填且用"-"分隔')
        return
      }
      if (Object.keys(extensionCode).length) param.extensionCode = JSON.stringify(extensionCode)
      this.$emit('create', param, { formItemList: this.formItemList, form: this.form })
    },
    handlePictureCardPreview(res) {
      if (res.errorCode === '0') {
        this.form.woPictures.push(res.url)
      } else {
        this.$message.error(res.errorMsg || res.errorMessage || '文件上传失败')
      }
    },
    handlewoDescribePreview(msg) {
      this.form.woDescribe = msg
    },
    delbtnpic(index) {
      this.$confirm('是否确认删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.woPictures.splice(index, 1)
      })
    },
    workImgs(val) {
      if (this.form.woPictures.length >= 5) {
        this.$message.error('最多上传5张图片')
        return
      }
      if ((val.split('http')).length - 1 > 1) {
        this.$message.error('请上传正确的图片地址')
        return
      }
      this.form.woPictures.push(val)
    }
  }
}
</script>

<style lang="less" scoped>
.create-group-view{
  /deep/ .item-template-view{
    .el-input{
      width: 200px;
    }
  }
}
/deep/ .drapUpload{
   .el-upload-dragger, .el-upload{
    width: 90px;
    height: 90px;
    line-height: 98px;
  }
  .imgList{
      display:inline-block;
      span{
        position:relative;
        margin-right:5px;
      }
      .el-icon-error{
        position:absolute;
        cursor:pointer;
        right:0;
        background:#ccc;
      }
      img{
        width:90px;
        height:90px;
        border-radius: 5px;
        display: inline-block;
        border: 1px solid #eee;
      }    
    }
}
/deep/ .dragWorkUpload{
  margin-top:10px;
}
</style>
